import type { Transaction } from 'dexie';
import { STORAGE_KEY_TENANT_ID } from '../constants';
import { TABLE_NAMES } from '../schema';

// Résolution du tenantId de migration. Contraintes :
//  - non destructif : on ne supprime aucune donnée existante (NO-GO Hamid D1) ;
//  - idempotent : relancer la migration ne doit pas écraser un tenantId déjà posé ;
//  - client-side : aucun call serveur, génération via crypto.randomUUID().
function resolveMigrationTenantId(): string {
  if (typeof globalThis.localStorage !== 'undefined') {
    const existing = globalThis.localStorage.getItem(STORAGE_KEY_TENANT_ID);
    if (existing && existing.length > 0) return existing;
    const generated = crypto.randomUUID();
    globalThis.localStorage.setItem(STORAGE_KEY_TENANT_ID, generated);
    return generated;
  }
  // Contexte sans localStorage (worker, SSR sans polyfill) — on génère un id
  // jetable. Le navigateur réel passera toujours par la branche localStorage.
  return crypto.randomUUID();
}

// Backfill `tenantId` sur tous les records pré-B-001. Idempotent : un record
// déjà tenant-aware n'est pas touché — pas d'écrasement, pas de fuite cross-tenant.
export async function upgradeAddTenantId(tx: Transaction): Promise<void> {
  const tenantId = resolveMigrationTenantId();
  for (const tableName of TABLE_NAMES) {
    const table = tx.table(tableName);
    await table.toCollection().modify((rec: { tenantId?: string }) => {
      if (!rec.tenantId) {
        rec.tenantId = tenantId;
      }
    });
  }
}
